import { render, staticRenderFns } from "./Fundingdetails.vue?vue&type=template&id=3c9b0089&scoped=true&"
import script from "./Fundingdetails.vue?vue&type=script&lang=js&"
export * from "./Fundingdetails.vue?vue&type=script&lang=js&"
import style0 from "./Fundingdetails.vue?vue&type=style&index=0&id=3c9b0089&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b0089",
  null
  
)

export default component.exports